var map = {
	"./2022_yuletide.jpg": 99,
	"./HaydnKlangspiel.jpg": 100,
	"./JocelynColm.jpg": 101,
	"./Juggling act 1.jpg": 102,
	"./MS Header1.gif": 37,
	"./MSLogo_Lg.gif": 38,
	"./MagicalStringsGroup.jpg": 103,
	"./MagicalStringsGroup_opt.jpg": 39,
	"./PhilipBlue.jpg": 104,
	"./Yuletide2021.png": 105,
	"./dancers_banner.jpg": 106,
	"./duo_with_dancers_1.jpg": 107,
	"./duo_with_dancers_3.jpg": 108,
	"./edited/finale_banner.jpg": 109,
	"./edited/jocelyn_solo.jpg": 110,
	"./img_dump/Album cover of Fairy Wind for PR and website.jpg": 111,
	"./img_dump/Cadence and Haydn.jpg": 112,
	"./img_dump/E5URhUDU.jpeg.jpg": 113,
	"./img_dump/Haydn higher in the air.jpg": 114,
	"./img_dump/Haydn in the air.jpg": 115,
	"./img_dump/IMG_2146.jpg": 116,
	"./img_dump/Jocelyn.jpg": 117,
	"./img_dump/Magical Strings 2018 (208 of 264).jpg": 118,
	"./img_dump/Magical Strings 2018 (221 of 264) (3).jpg": 119,
	"./img_dump/Magical Strings 2018 (226 of 264) stage left at end.jpg": 120,
	"./img_dump/Magical Strings 2018 (242 of 264).jpg": 121,
	"./img_dump/Magical Strings 2018 (34 of 264).jpg": 122,
	"./img_dump/Magical Strings 2018 (95 of 264).jpg": 123,
	"./img_dump/Magical Strings 2018 (99 of 264).jpg": 124,
	"./img_dump/MagicalStringsGroup_orig.jpg": 125,
	"./img_dump/brothers' dancing.jpg": 126,
	"./img_dump/brothers' in the air.jpg": 127,
	"./img_dump/cover4.jpg": 128,
	"./img_dump/processionial (2).jpg": 129,
	"./knot.png": 130,
	"./loading.gif": 131,
	"./loading.png": 132,
	"./ms_events.jpg": 36,
	"./ms_events_opt.jpg": 133,
	"./philip_harps_opt.jpg": 35,
	"./slides/slide_0.jpg": 134,
	"./slides/slide_1.jpg": 135,
	"./slides/slide_10.jpg": 136,
	"./slides/slide_11.jpg": 137,
	"./slides/slide_12.jpg": 138,
	"./slides/slide_13.jpg": 139,
	"./slides/slide_14.jpg": 140,
	"./slides/slide_2.jpg": 141,
	"./slides/slide_3.jpg": 142,
	"./slides/slide_4.jpg": 143,
	"./slides/slide_5.jpg": 144,
	"./slides/slide_6.jpg": 145,
	"./slides/slide_7.jpg": 146,
	"./slides/slide_8.jpg": 147,
	"./slides/slide_9.jpg": 148,
	"./thumbnail_theater_2023.jpg": 149,
	"./underconstruction.png": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;